import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/CloseRounded';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';
import DOMPurify from 'dompurify';
import Alert from '@mui/material/Alert';
import RssFeedIcon from '@mui/icons-material/RssFeedRounded';
import ContentCopyIcon from '@mui/icons-material/ContentCopyRounded';
import { formatDateTime, formatDateTimeUTC } from '../../../helpers'
import {storage} from '../../../storage'
import Snackbar from '@mui/material/Snackbar';

function TestRssModal(props) {   
    const [showUrl, setShowUrl] = useState(false)
    const [fullList, setFullList] = useState(storage.rssTest.fullList)
    const [showCopyAlert, setShowCopyAlert] = useState()
        
    const rawMarkup = (content) => {
        var rawMarkup = content
        return { __html: DOMPurify.sanitize(rawMarkup) };
    }
        
    return (
        <Dialog open={props.items ? true : false} onClose={() => {props.onClose()}} fullWidth maxWidth="lg" >
            <DialogTitle id="alert-dialog-title">
                Test Rss Query
                <IconButton
                    onClick={props.onClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {props.error ?
                <Alert severity="error" sx={{mb:2,wordBreak: 'break-word'}}>
                    {props.error}
                </Alert>
                : null }
                <Stack direction="row" alignItems="center" sx={{pb:1}}>
                    <Typography variant="h6" sx={{mr:6}}>
                        Total: {props.items?.length}
                    </Typography>
                    
                    <FormControlLabel control={
                        <Switch
                            edge="end"
                            size="small"
                            onChange={(e) => {setFullList(e.target.checked)}}
                            checked={fullList}
                            sx={{ml:2,mr:0.25}}
                        />
                    } label="Show Descriptions" />
                    
                    <Stack sx={{flexGrow: 1}} />
                
                    <Button 
                        startIcon={<RssFeedIcon />}
                        onClick={() => {setShowUrl(!showUrl)}}
                    >
                        Rss Url
                    </Button>
                </Stack>
                {showUrl ?
                <Alert 
                    severity="info" 
                    sx={{mb:2,wordBreak: 'break-word'}}
                    action={
                        <Tooltip
                            title="Copy Rss Url to Clipboard"
                        >   
                            <span>
                                <IconButton onClick={() => {
                                    if (props.url) {
                                        navigator.clipboard?.writeText(encodeURI(props.url).replace(/'/g, "%27"))
                                    }
                                    setShowCopyAlert(true)
                                }}>
                                    <ContentCopyIcon/>
                                </IconButton>
                            </span>
                        </Tooltip>
                    }
                >
                    {props.url || 'No URL returned'}
                </Alert>
                : null }
                <TableContainer component={Paper}>
                    <Table>
                        <TableBody>
                            {props.items?.map((row) => {
                                if (fullList) {
                                    return (
                                        <TableRow
                                            key={row.guid}
                                            sx={{ 'td': {borderTop: '0.5px solid rgba(224, 224, 224, 1)'}, opacity: row.archived ? 0.4 : 1 }}
                                        >
                                            <TableCell align="left" sx={{ overflowX: 'hidden', wordWrap: 'break-word' }}>
                                                <Stack spacing={1}>
                                                    <Typography variant="h6">
                                                        {row.title}
                                                    </Typography>
                                                    <div style={{marginTop: '10px', paddingBottom: '30px'}} dangerouslySetInnerHTML={rawMarkup(row.content)} />
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    )
                                } else {
                                    return (
                                        <TableRow
                                            key={row.guid}
                                            sx={{ 'td': {borderTop: '0.5px solid rgba(224, 224, 224, 1)'}, opacity: row.archived ? 0.4 : 1 }}
                                        >
                                            <TableCell align="left" sx={{width: '150px', py:1, overflowX: 'hidden', wordWrap: 'break-word' }}>
                                                {formatDateTime(row.iso_date)}
                                            </TableCell>
                                            <TableCell align="left" sx={{py:1, overflowX: 'hidden', wordWrap: 'break-word' }}>
                                                {row.title}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            })}
                            {props.items?.length ? null :
                            <TableRow>
                                <TableCell sx={{p:5, textAlign: 'center'}}>No data to display</TableCell>
                            </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onClose()}}>Close</Button>
            </DialogActions>
            <Snackbar open={showCopyAlert} autoHideDuration={4000} onClose={() => setShowCopyAlert(false)}>
                <Alert onClose={() => setShowCopyAlert(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
                    The Rss Url has been successfully copied to the clipboard.
                </Alert>
            </Snackbar>
        </Dialog>
    )
}

export default TestRssModal